import { render } from "./TableActions.vue?vue&type=template&id=334bf088&scoped=true"
import script from "./TableActions.vue?vue&type=script&lang=js"
export * from "./TableActions.vue?vue&type=script&lang=js"

import "./TableActions.vue?vue&type=style&index=0&id=334bf088&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-334bf088"

export default script